import type { MemCacheService } from './mem-cache.service'

export type CacheService = Pick<MemCacheService, 'get' | 'set' | 'clear'>

// Cache que nunca guarda nada. Default do backend quando nenhuma cache é injetada: compartilhar uma
// cache em memória entre empresas seria risco de vazamento de dado (MemCacheService usa hash de 32 bits
// como chave, sem garantia de unicidade, e nunca expira por conta própria em processos de vida longa).
export class NoOpCacheService implements CacheService {
    get(_key: string, _cacheAgeLimitInSeconds: number) {
        return null
    }
    set(_key: any, _object: any, _clearKey: any) {}
    clear(_clearKey: any) {}
}
